import { render, staticRenderFns } from "./swiper-card.vue?vue&type=template&id=693d89ee&scoped=true&"
import script from "./swiper-card.vue?vue&type=script&lang=js&"
export * from "./swiper-card.vue?vue&type=script&lang=js&"
import style0 from "./swiper-card.vue?vue&type=style&index=0&id=693d89ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693d89ee",
  null
  
)

export default component.exports